import { logAnalytics } from "./analytics";

export const logPageView = (pathname: string) => {
  logAnalytics("page_view", { page: pathname });
  console.log("[ANALYTICS] Page view:", pathname);
};

export const logFormSubmit = (formName: string) => {
  logAnalytics("form_submit", {
    form_name: formName,
    page: window.location.pathname,
  });
  console.log("[ANALYTICS] Form submit:", formName);
};

export const logFormStart = (formName: string) => {
  logAnalytics("form_start", {
    form_name: formName,
    page: window.location.pathname,
  });
  console.log("[ANALYTICS] Form start:", formName);
};

export const logCTA = (
  name: string,
  location?: string,
  redirect?: {
    url?: string;
    section_id?: string;
    page_path?: string;
  }
) => {
  const params = {
    cta_name: name,
    page: window.location.pathname,
    ...(redirect?.url || redirect?.section_id || redirect?.section_id
      ? {
          cta_redirect:
            redirect.url ||
            (redirect.page_path || window.location.pathname) +
              (redirect.section_id ? `#${redirect.section_id}` : ""),
        }
      : {}),
  };
  logAnalytics("cta_click", params);
  console.log("[ANALYTICS] CTA click:", params);
};
